<template>
  <div class="inner" style="padding: 20px 0;width: 100%">
    <el-container style="display: flex;flex-direction: column;align-items: center">
      <el-container style="margin-bottom: 70px">
        <!--        左半部分-->
        <el-aside width="3rem" style="border: .01rem solid #CCCCCC">
          <el-container style="padding: 0.2rem 0;">
            <!--            分类部分-->
            <el-header style="height: 6.4rem;overflow-y: auto;padding-bottom: 20px">
              <el-tree ref="menuTree" :data="data" node-key="id" :props="defaultProps"  @node-click="handleNodeClick" highlight-current />
            </el-header>
            <!--            联系我们-->
<!--            <el-main style="display: flex;flex-direction: column;border-top: 0.01rem solid #228457;overflow-y: auto">
              <div style="display: flex;align-items: flex-start;flex-direction: column;line-height: .3rem">
                <span style="font-size: 18px;font-weight: bold;letter-spacing: 2px;margin-bottom: .1rem;margin-top: .1rem">联系我们</span>
                <ul>
                  <li>联系人：贾英培</li>
                  <li>联系方式：市电（010）51873644</li>
                </ul>
              </div>
              <div style="display: flex;align-items: flex-start;flex-direction: column;line-height: .3rem;border-top: 0.01rem solid #228457">
                <span style="font-size: 18px;font-weight: bold;letter-spacing: 2px;margin-bottom: .1rem;margin-top: .1rem">成为我们签约摄影师</span>
                <ul>
                  <li>联系人：金锋</li>
                  <li>联系方式：市电（010）51873644</li>
                  <li>联系方式：路电（021）73125</li>
                </ul>
              </div>
              <div style="display: flex;align-items: flex-start;flex-direction: column;line-height: .3rem;border-top: 0.01rem solid #228457">
                <span style="font-size: 18px;font-weight: bold;letter-spacing: 2px;margin-bottom: .1rem;margin-top: .15rem" @click="aboutMe()">关于我们</span>
              </div>
            </el-main>-->
          </el-container>
        </el-aside>
        <!--        右半部分-->
        <el-container style="display: flex;flex-direction: column;align-items: center">
          <el-header style="margin-bottom: .2rem;width: 100%;height: .45rem">
<!--            <input v-model="name" placeholder="输入图片名称" size="mini" clearable>-->
            <el-autocomplete v-model="name" style="width: 100%;" :fetch-suggestions="querySearch" placeholder="输入关键词" @select="handleSelect" prefix-icon="el-icon-search" >
            </el-autocomplete>
            <el-button icon="el-icon-search" @click="handleSelect()">搜索</el-button>
          </el-header>


          <el-main style="padding: 0 0.2rem;height: auto;width: 10rem">
            <el-row :gutter="20">
              <el-col :span="6" v-for="item of rows" :key="item.VProductId">
                <div class="grid-content bg-purple" >
                  <div>
                    <div class="file-img" @click="toImg(item.VAttachmentId)">
                      <img :src="item.VAttachmentRemotePath" style="height: 100%;width: 100%;object-fit: cover;"/>
                    </div>
                    <div class="file-info">
                      <p class="info-VProductName">{{ item.VAttachmentName }}</p>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-main>
          <el-aside style="width: auto;padding-top: 20px" v-if="rows.length">
            <el-pagination
              background
              layout="prev, pager, next"
              :current-page.sync="current"
              :total="total"
              :page-size="pageSize"
              @current-change="getPage"
            >
            </el-pagination>
          </el-aside>
        </el-container>
      </el-container>
    </el-container>
    <!-- 添加购物车提示 -->

    <el-dialog :visible.sync="dialogTableVisible">
      <div style="display: flex;align-items: flex-start;flex-direction: column;line-height: .3rem">
        <span style="font-size: 20px;font-weight: bold;letter-spacing: 2px;margin-bottom: .1rem">关于我们</span>
        <ul>
          <li><i class="el-icon-s-opportunity" style="color: #ffbe00;font-size: 18px"></i>你是否拍摄过各类题材的铁路图片，却都放在”抽屉”里没有作为？</li>
          <li><i class="el-icon-s-opportunity" style="color: #ffbe00;font-size: 18px"></i>你有意成为我们的签约摄影师，将作品分享给更多人，让作品实现收益吗？</li>
          <li><i class="el-icon-s-opportunity" style="color: #ffbe00;font-size: 18px"></i>你是否一直在寻找能给你提供高清的铁路图片网站？</li>
          <li><i class="el-icon-s-opportunity" style="color: #ffbe00;font-size: 18px"></i>你是否总是找不到想要的图片？</li>
        </ul>
      </div>
      <div style="display: flex;align-items: flex-start;flex-direction: column;line-height: .3rem">
        <span style="font-size: 18px;font-weight: bold;letter-spacing: 2px;margin-bottom: .1rem;margin-top: .1rem">创意服务</span>
        <ul>
          <li><i class="el-icon-s-promotion" style="color: #0700ff;font-size: 18px"></i>优质版权作品下载</li>
          <li><i class="el-icon-s-promotion" style="color: #0700ff;font-size: 18px"></i>作品商用变现</li>
          <li><i class="el-icon-s-promotion" style="color: #0700ff;font-size: 18px"></i>创意灵感库</li>
          <li><i class="el-icon-s-promotion" style="color: #0700ff;font-size: 18px"></i>企业商用授权服务</li>
        </ul>
      </div>
    </el-dialog>

  </div>


</template>

<script>
import { jump, getUser } from '@/untils/auth'
  export default {
    name: "pictureShare",
    components: {},
    data() {
      return {
        publicPath: location.origin + location.pathname,
        rows: [],
        activeIndex: "1",
        name: "",
        total: 200,
        pageSize: 12,
        current: '0',
        categoryid: "",
        querycategoryname: "",
        data: [],
        message: [],
        dialogTableVisible: false,
       /* defaultProps: {
          children: 'children',
          label: function(data, node){
            // console.log(data)
            return data.text+"("+data.number+")";
          },
          number: 'number',
        },*/
        defaultProps: {
          children: 'children',
          label: function(data, node){
            return data.text;
          },
        },
        labelList: [],
        keyrord: '',
        VAttachmentName: '',
        serarchVal: '',
        author: '',
      }
    },
    created() {
      // this.current = this.$route.query.current;
      // this.name = this.$route.query.searchtext;
      this.querycategoryname = this.$route.query.categoryid;
      var serarchVal = this.$route.query.serarchVal;
      var searchKey = this.$route.query.searchKey;
      if (searchKey=='keyrord'){
        this.name=serarchVal;
      }
      if (searchKey=='VAttachmentName'){
        this.VAttachmentName=serarchVal;
      }
      if (searchKey=='author'){
        this.author=serarchVal;
      }
      if (searchKey=='serarchVal'){
        this.serarchVal=serarchVal;
      }

      this.getCategroy();

      this.getHot();
    },
    methods: {
      jump,
      getHot() {
        if (getUser()) {
          var createdBy = JSON.parse(getUser()).principal.VUserId;
          var data = {key: "ess_picture_hotSearch_"+createdBy}
          this.axios.post(window.IPConfig.IP + "/tBHotSearch/queryKeyHotSearCher.do", data).then((res) => {
            if (res.data.status == 200) {
              this.labelList = res.data.obj
            }
          });
        }
      },


      // 点击分类事件
      handleNodeClick(data) {
        // console.log(data)
        this.categoryid = data.id;
        this.categoryname = data.text;
        this.name = '';
        this.VAttachmentName='';
        this.author='';
        this.serarchVal='';
        this.current=0;
        this.getData();
      },
      aboutMe(){
        this.dialogTableVisible = true
      },
      // 切换页码事件
      getPage(val){
        this.current = val;
        this.getData();
      },
      // 跳转图片详情
      toImg(VProductId){
        let routeData = this.$router.resolve({path:'imageDetails',query:{
            VProductId: VProductId,
            current: this.current,
            searchtext: this.name,
            categoryid: this.categoryid,
          }})

        window.open(routeData.href,'_blank')

      /*  this.$router.push(
          {
            path: 'imageDetails',
            query: {
              VProductId: VProductId,
              current: this.current,
              searchtext: this.name,
              categoryid: this.categoryid,
            }
          }
        )*/
      },
      // 获取分类列表
      getCategroy() {
        this.axios.post(window.IPConfig.IP + "/tBCategory/getTree2.do",{
          VModulerId: 'fcface19b4ae482581d7a5a403e72331'
        }).then((res) => {
          this.data = res.data.obj || [];
          // this.categoryid = this.data[0].id;
          // this.categoryname = this.data[0].text;
          if (this.querycategoryname!=null && this.querycategoryname!=''){
            for(let i=0;i<res.data.obj.length;i++){
              if (res.data.obj[i].parenIid ==-1 && res.data.obj[i].id==this.querycategoryname){
                this.categoryid =res.data.obj[i].id;
                this.categoryname = res.data.obj[i].text;
              }
            }
          }


          let targetNodeKey = this.categoryid;
          if (targetNodeKey !=null){
            this.$nextTick(() => {
              //判断是否存在指定节点
              if (this.$refs.menuTree.getNode(targetNodeKey)) {
                //若存在指定节点，则设置当前节点为指定节点（用于高亮显示当前节点）
                this.$refs.menuTree.setCurrentKey(targetNodeKey)
                // this.$refs.menuTree.setCurrentNode(targetNodeKey)
                //展开指定节点
                this.$refs.menuTree.store.nodesMap[targetNodeKey].expanded = true;
                var selected = this.$refs.menuTree.getCurrentNode();
                if (this.$refs.menuTree.getNode(selected) && this.$refs.menuTree.getNode(selected).parent) {
                  this.expandParents(this.$refs.menuTree.getNode(selected).parent)
                }
              }
            })
          }else {
              //若不存在指定节点，则设置当前节点为null（清除当前节点的高亮效果）
              this.$refs.menuTree.setCurrentKey()
          }

          this.getData();
        });


      },
      // 展开所有祖宗节点
      expandParents (node) {
        node.expanded = true
        if (node.parent) {
          this.expandParents(node.parent)
        }
      },
      // 图片列表   点击搜索
      getData() {
          var data = {
            auditStatus: "1",
            VAttachmentType: '1',
            IProductStatut: 0,
            categoryid: (this.categoryid == undefined ||this.categoryid == 88888)? '' : this.categoryid,
            size: this.pageSize,
            current: this.current == undefined ? 0 : this.current,
            // serarchUser:getUser()==undefined ?'' :JSON.parse(getUser()).principal.VUserId,
            keyrord:this.name,
            VAttachmentName:this.VAttachmentName,
            author:this.author,
            serarchVal:this.serarchVal,
          }
          this.axios.post(window.IPConfig.IP + "/tBAttachments/queryauditStatusPage.do", data).then((res) => {
            this.rows = [];
            if (res.data.status == 200) {
              this.rows = res.data.obj ? res.data.obj.records : [];
              this.total = Number(res.data.obj.total);
            }
          });
          this.getHot();
      },

      querySearch(queryString, cb) {
        let programList = [];
        for(let i=0;i<this.labelList.length;i++){
          programList.push({'value':this.labelList[i]})
        }

        let results = queryString ? programList.filter(this.createFilter(queryString)) : programList;
        //基本思路就是实现一个过滤器，过滤存在你输入字段的所有数据。
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 1000 * Math.random());
      },


      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.indexOf(queryString) > -1);
        };
      },
      handleSelect(item) {
        // this.name = '';
        this.VAttachmentName='';
        this.author='';
        this.current=0;
        this.getData();
      },

    },
  };
</script>
<style lang="stylus" scoped>
  .el-row {
    margin-bottom: 0.1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .file-img {
    text-align: center;
    /*background: #f2f3f4;*/
    padding: 0.1rem;
    height: 1.65rem;
    cursor: pointer;
    object-fit :cover;
  }

  .el-header{
    display: flex;
    overflow: hidden;
  }

  ::-webkit-scrollbar {
    display: none;
  }

  input{
    width:100%;
    height: auto;
    padding: .1rem 1.2rem .1rem .1rem;
    border: .01rem solid #0e5278;
    border-right: none;
  }

  .el-button{
    border-radius: 0 4px 4px 0;
  }

  .file-info {
    background: #fdffff;
    padding: 0 0.1rem;
    box-sizing: border-box;
    text-align: center;
    overflow: hidden;
    height: auto;
  }

  // 标题
  .info-VProductName {
    text-align: center;
    line-height: 0.25rem;
    height: 0.25rem;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    word-break: break-all;
    -webkit-box-orient: vertical;
  }

  // 内容描述
  .info-VProductDesc {
    text-align: left;
    line-height: 0.25rem;
    height: 0.5rem;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    word-break: break-all;
    -webkit-box-orient: vertical;
  }

  .info-price {
    display: flex;
    justify-content: center;
    /* justify-content: space-between; */
  }

  // 搜索
  .search-key {
    display: flex;
    justify-content: flex-end;
  }

  .search-input {
    display: flex;
    border: 1px solid $backgroundCOlor;
    margin-right: 0.1rem;
    width: 3rem;
    height: 100%;
  }

  .input-text {
    width: 100%;
  }

  .search-input >>> .el-button {
    background: $backgroundCOlor;
    border-radius: 0;
    border: none;
  }

  .search-input >>> .el-input__inner {
    height: 0.3rem;
    line-height: 0.3rem;
    border: none;
    border-radius: 0;
  }
  .el-autocomplete >>> .el-input__inner{
    height 0.45rem !important;
    border:1px solid #cccccc !important
  }
  .inner {
    position: relative;
  }

  .tree {
    width: 300px;
    overflow: auto;
    position: absolute;
    top: 20px;
    left: -310px;
  }


  .el-button {
    background: #f2f3f4;
    border-color: #f2f3f4;
    color: cadetblue;
  }


</style>



// WEBPACK FOOTER //
// src/components/Education/pictureShare.vue